import { render, staticRenderFns } from "./AccountRegisterUser.vue?vue&type=template&id=580bd89a"
import script from "./AccountRegisterUser.vue?vue&type=script&lang=js"
export * from "./AccountRegisterUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports